export default "__VITE_ASSET__uiH6pdHb__"